// Propratni dokumenti koraka: zapis može imati samo naziv (dokument u papiru),
// link, otpremljen fajl (is_file) ili naziv i link. Zapis bez ičega se ne šalje.
export const hasDocumentContent = (doc) =>
  Boolean(
    doc?.is_file ||
      String(doc?.name || "").trim() ||
      String(doc?.path || "").trim()
  );

// Serveru idu samo id, naziv i link; polja fajla server nikad ne čita iz tela.
export const cleanDocuments = (documents) =>
  (documents || [])
    .filter(hasDocumentContent)
    .map(({ id, name, path }) => ({ id, name, path }));

// Klikabilni su samo http(s) linkovi; adrese koje počinju sa "www." dobijaju
// https://. Sve ostalo (npr. javascript:) prikazuje se kao običan tekst.
export const getSafeDocumentHref = (path) => {
  const value = String(path || "").trim();
  if (/^https?:\/\//i.test(value)) return value;
  if (/^www\./i.test(value)) return `https://${value}`;
  return null;
};
